import type { AppIconName } from './AppIcon';

/** Maps game ids → AppIcon names for lobby carousel / selected-game chrome. */
const GAME_ICON_MAP: Record<string, AppIconName> = {
  trivia: 'psychology',
  'word-puzzle': 'extension',
  'speed-challenge': 'bolt',
  'picture-perfect': 'photoCamera',
  'close-or-not': 'trackChanges',
  'fact-or-myth': 'travelExplore',
  'almost-genius': 'psychology',
  'pair-matching': 'gridView',
  'collaborative-puzzle': 'handshake',
  'story-chain': 'menuBook',
  'break-the-code': 'lock',
  associations: 'mic',
  'catch-shout-catch': 'campaign',
  'house-run': 'directionsRun',
  'one-brain': 'hub',
  'drinking-game': 'localBar',
  'hot-takes': 'whatshot',
  'would-you-rather': 'compareArrows',
  'are-you-drunk': 'sportsBar',
  'vision-check': 'visibility',
  'rapid-fire': 'bolt',
  'stoned-yet': 'spa',
  'kinky-or-not': 'favorite',
  'play-it-loud': 'musicNote',
  'party-pair-matching': 'gridView',
  'agile-quiz': 'assignment',
  'tech-trivia': 'computer',
  'business-brain-teasers': 'businessCenter',
  'its-funny': 'sentimentSatisfied',
  'before-or-after': 'schedule',
  'team-pair-matching': 'gridView',
  'what-could-it-be': 'visibility',
  'clue-in': 'lightbulb',
  'what-am-i': 'face',
  'how-many': 'tag',
  'family-pair-matching': 'gridView',
  'guess-what': 'celebration',
  'family-trivia': 'familyRestroom',
  'animal-quiz': 'pets',
  'wonder-world': 'public',
  'odd-one-out': 'extension',
  'estimate-it': 'barChart',
  'true-or-silly': 'sentimentSatisfied',
};

export function getGameIconName(gameId: string): AppIconName {
  return GAME_ICON_MAP[gameId] ?? 'gamepad';
}
